<template>
  <div data-v-e5781868="" class="app-wrapper">
    <div data-v-e5781868="" class="leftSliderBarWrap">
      <div data-v-7ad90110="" data-v-e5781868="" class="leftSliderBar">
        <a data-v-7ad90110="" class="toggle"
          ><span data-v-7ad90110="" class="close"
            ><svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon closeSidebar">
              <use data-v-338e1447="" xlink:href="#icon-closeSidebar"></use></svg></span
          ><span data-v-7ad90110="" class="open"
            ><svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon openSidebar">
              <use data-v-338e1447="" xlink:href="#icon-openSidebar"></use></svg></span
        ></a>
        <div data-v-7ad90110="" class="defaultState">
          <div data-v-7ad90110="" class="top" @click="goNav('/')" style="cursor: pointer">
            <img style="width: 1.62rem; height: 0.67rem; display: block" v-if="$store.state.appInfo.site_logo && logoShow" :src="$store.state.appInfo.site_logo" @error="logoShow = false" alt="" />

            <svg data-v-338e1447="" v-else data-v-7ad90110="" aria-hidden="true" class="svg-icon logo">
              <use data-v-338e1447="" xlink:href="#icon-logo"></use>
            </svg>
          </div>
          <div data-v-7ad90110="" class="c">
            <div data-v-7ad90110="" class="navigation">
              <ul data-v-7ad90110="" class="group1">
                <a href="javascript:void(0);" @click="goNav('/')">
                  <li data-v-7ad90110="" :class="path == '/' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconHome">
                      <use data-v-338e1447="" xlink:href="#icon-iconHome"></use>
                    </svg>
                    <h3 data-v-7ad90110="">首页</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/realPerson')">
                  <li data-v-7ad90110="" :class="path == '/realPerson' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLive">
                      <use data-v-338e1447="" xlink:href="#icon-iconLive"></use>
                    </svg>
                    <h3 data-v-7ad90110="">真人</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/electronics')">
                  <li data-v-7ad90110="" :class="path == '/electronics' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGames">
                      <use data-v-338e1447="" xlink:href="#icon-iconGames"></use>
                    </svg>
                    <h3 data-v-7ad90110="">电游</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/sports')">
                  <li data-v-7ad90110="" :class="path == '/sports' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconSports">
                      <use data-v-338e1447="" xlink:href="#icon-iconSports"></use>
                    </svg>
                    <h3 data-v-7ad90110="">体育</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/eSports')">
                  <li data-v-7ad90110="" :class="path == '/eSports' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGames">
                      <use data-v-338e1447="" xlink:href="#icon-iconGames"></use>
                    </svg>
                    <h3 data-v-7ad90110="">电竞</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/lottery')">
                  <li data-v-7ad90110="" :class="path == '/lottery' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLottery">
                      <use data-v-338e1447="" xlink:href="#icon-iconLottery"></use>
                    </svg>
                    <h3 data-v-7ad90110="">彩票</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/cards')">
                  <li data-v-7ad90110="" :class="path == '/cards' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconCards">
                      <use data-v-338e1447="" xlink:href="#icon-iconCards"></use>
                    </svg>
                    <h3 data-v-7ad90110="">棋牌</h3>
                  </li>
                </a>
              </ul>
              <div data-v-7ad90110="" class="separator"></div>
              <ul data-v-7ad90110="">
                <li data-v-7ad90110="" :class="path == '/discount' ? 'active' : ''">
                  <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGifts">
                    <use data-v-338e1447="" xlink:href="#icon-iconGifts"></use>
                  </svg>
                  <a href="javascript:void(0);" @click="goNav('/discount')">
                    <h3 data-v-7ad90110="">最新优惠</h3>
                  </a>
                  <!-- <span data-v-7ad90110="" class="num">1</span> -->
                </li>
              </ul>
              <div data-v-7ad90110="" class="group" style="display: ">
                <div data-v-7ad90110="" class="separator"></div>
                <ul data-v-7ad90110="">
                  <a href="javascript:void(0);">
                    <li data-v-7ad90110="" :class="path == '/accountSetting' ? 'active' : ''" @click="goNav('/accountSetting')">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconUser">
                        <use data-v-338e1447="" xlink:href="#icon-iconUser"></use>
                      </svg>
                      <h3 data-v-7ad90110="">会员中心</h3>
                    </li>
                    <li data-v-7ad90110="" class="" @click="getAgentLoginUrl">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconStar">
                        <use data-v-338e1447="" xlink:href="#icon-iconStar"></use>
                      </svg>
                      <h3 data-v-7ad90110="">代理登录</h3>
                    </li>
                    <li data-v-7ad90110="" :class="path == '/vip' ? 'active' : ''" @click="goNav('/vip')">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconVip">
                        <use data-v-338e1447="" xlink:href="#icon-iconVip"></use>
                      </svg>
                      <h3 data-v-7ad90110="">VIP俱乐部</h3>
                    </li>
                  </a>
                </ul>
                <!-- <div data-v-7ad90110="" class="box box2"><svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon iconStar">
									<use data-v-338e1447="" xlink:href="#icon-iconStar"></use>
									</svg><span data-v-7ad90110="">常玩游戏</span><span data-v-7ad90110="" class="value">0</span></div> -->
              </div>
            </div>
            <div data-v-7ad90110="" class="qrBox">
              <div data-v-7ad90110="" class="qr">
                <div data-v-7ad90110="" class="qr-img" :title="$store.state.appInfo.ios_download_url">
                  <!-- <img
                    data-v-7ad90110=""
                    src="data:image/png;base64,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"
                    alt=""
                    class="qr-code-logo"
                  /> -->
                  <!-- <canvas width="106" height="106" style="display: none"></canvas> -->
                  <img alt="Scan me!" :src="$store.state.appInfo.ios_download_qrcode"  onerror="this.src = '/static/image/appurl.jpg'" style="display: block; width: 100%" />
                </div>
              </div>
              <p data-v-7ad90110="">扫码下载{{ $store.state.appInfo.title }}APP</p>
            </div>
          </div>
        </div>
        <div data-v-7ad90110="" class="minState">
          <div data-v-7ad90110="" class="top">
            <!-- <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon logo2">
              <use data-v-338e1447="" xlink:href="#icon-logo2"></use>
            </svg> -->
            <img src="/static/image/minilogo.png" style="width: 0.6rem; height: 0.6rem" alt="" />
          </div>
          <div data-v-7ad90110="" class="c">
            <div data-v-7ad90110="" class="navigation">
              <ul data-v-7ad90110="" class="group1">
                <a @click="goNav('/')" href="javascript:void(0);">
                  <li data-v-7ad90110="" :class="path == '/' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconHome">
                      <use data-v-338e1447="" xlink:href="#icon-iconHome"></use></svg
                    ><span data-v-7ad90110="" class="title">首页</span>
                  </li>
                </a>
                <a @click="goNav('/realPerson')" href="javascript:void(0);">
                  <li data-v-7ad90110="" :class="path == '/realPerson' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLive">
                      <use data-v-338e1447="" xlink:href="#icon-iconLive"></use></svg
                    ><span data-v-7ad90110="" class="title">真人</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/electronics')">
                  <li data-v-7ad90110="" :class="path == '/electronics' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGames">
                      <use data-v-338e1447="" xlink:href="#icon-iconGames"></use></svg
                    ><span data-v-7ad90110="" class="title">电游</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/sports')">
                  <li data-v-7ad90110="" :class="path == '/sports' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconSports">
                      <use data-v-338e1447="" xlink:href="#icon-iconSports"></use></svg
                    ><span data-v-7ad90110="" class="title">体育</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/lottery')">
                  <li data-v-7ad90110="" :class="path == '/lottery' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLottery">
                      <use data-v-338e1447="" xlink:href="#icon-iconLottery"></use></svg
                    ><span data-v-7ad90110="" class="title">彩票</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/cards')">
                  <li data-v-7ad90110="" :class="path == '/cards' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconCards">
                      <use data-v-338e1447="" xlink:href="#icon-iconCards"></use></svg
                    ><span data-v-7ad90110="" class="title">棋牌</span>
                  </li>
                </a>
              </ul>
              <div data-v-7ad90110="" class="separator"></div>
              <ul data-v-7ad90110="">
                <a href="javascript:void(0);" @click="goNav('/discount')">
                  <li data-v-7ad90110="" :class="path == '/discount' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGifts">
                      <use data-v-338e1447="" xlink:href="#icon-iconGifts"></use>
                    </svg>
                    <span data-v-7ad90110="" class="title">最新优惠</span>
                  </li>
                </a>
              </ul>
              <div data-v-7ad90110="" class="group" style="display: ">
                <div data-v-7ad90110="" class="separator"></div>
                <ul data-v-7ad90110="">
                  <a href="javascript:void(0);">
                    <li data-v-7ad90110="" :class="path == '/accountSetting' ? 'active' : ''">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconUser" @click="goNav('/accountSetting')">
                        <use data-v-338e1447="" xlink:href="#icon-iconUser"></use></svg
                      ><span data-v-7ad90110="" class="title">会员中心</span>
                    </li>

                    <div data-v-7ad90110="" @click="getAgentLoginUrl" class="box box2">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon iconStar">
                        <use data-v-338e1447="" xlink:href="#icon-iconStar"></use></svg
                      ><span data-v-7ad90110="" class="title">代理登录</span>
                    </div>
                    <li data-v-7ad90110="" :class="path == '/vip' ? 'active' : ''" @click="goNav('/vip')">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconVip">
                        <use data-v-338e1447="" xlink:href="#icon-iconVip"></use></svg
                      ><span data-v-7ad90110="" class="title">VIP俱乐部</span>
                    </li>
                  </a>
                </ul>
              </div>
            </div>
            <div data-v-7ad90110="" class="qrBox">
              <div data-v-7ad90110="" class="qr"><img data-v-7ad90110="" src="/static/image/qr2.e81f9008.jpg" /></div>
              <div data-v-7ad90110="" class="qrBoxWarp">
                <div data-v-7ad90110="" class="qr-img" :title="$store.state.appInfo.ios_download_url">
                  <!-- <img
                    data-v-7ad90110=""
                    :src="$store.state.appInfo.ios_download_qrcode"
                    class="qr-code-logo"
                  /> -->
                  <!-- <canvas width="106" height="106" style="display: none"></canvas> -->
                  <img alt="Scan me!" :src="$store.state.appInfo.ios_download_qrcode"  onerror="this.src = '/static/image/appurl.jpg'" style="display: block; width: 100%" />
                </div>
                <p data-v-7ad90110="">扫码下载{{ $store.state.appInfo.title }}APP</p>
              </div>
            </div>
          </div>
        </div>
        <div data-v-7ad90110="" class="user-level">0/0</div>
      </div>
    </div>
    <div data-v-e5781868="" class="mainContentWrap leftSliderOpen">
      <Header />

      <router-view />
      <div data-v-5abf1f28="" data-v-011e1fb8="" id="homeFooter" class="footer">
        <div data-v-5abf1f28="" class="fixed-bottom">
          <!----><!----><!----><!----><!---->
          <div data-v-05425edc="" data-v-5abf1f28="" class="stockDividendPendant min" style="display: none">
            <div data-v-05425edc="" class="stockDividendPendant_txt"><span data-v-05425edc="" class="stockDividendPendant_txt_num"></span>时<span data-v-05425edc="" class="stockDividendPendant_txt_num"></span>分<span data-v-05425edc="" class="stockDividendPendant_txt_num"></span>秒<!----></div>
          </div>
          <!----><!---->
          <div data-v-5abf1f28="" class="clear"></div>
          <div data-v-5abf1f28="" class="clearfix"></div>
          <div data-v-5abf1f28="" class="clear"></div>
          <div data-v-5abf1f28="" class="tool">
            <a data-v-5abf1f28="" class="btn-min btm-icons" @click="openKefu()"
              ><svg data-v-338e1447="" data-v-5abf1f28="" aria-hidden="true" class="svg-icon cs"><use data-v-338e1447="" xlink:href="#icon-cs"></use></svg></a
            ><!---->
            <div data-v-5abf1f28="" class="clear"></div>
          </div>
          <!----><!---->
        </div>
      </div>
      <Foot />
    </div>

    <AllLogin />
    <div data-v-3e52ce59="" class="loading" v-if="loading">
      <div data-v-3e52ce59="" class="loader"><span data-v-3e52ce59="" class="load-img"></span></div>
    </div>
  </div>
</template>

<script>
import Header from './libs/Header';
import Foot from './libs/Foot';
import AllLogin from './libs/allLogin';
export default {
  name: 'Main',
  data() {
    return { path: '/', loading: false ,logoShow:true};
  },
  components: {
    Header,
    Foot,
    AllLogin,
  },
  created() {
    let that = this;
  },
  updated() {},
  mounted() {
    jQuery('.marquee').slide({ mainCell: '.marquee-box ul', autoPage: true, effect: 'topLoop', autoPlay: true, vis: 4, mouseOverStop: false, delayTime: 700 });
    //隐藏左侧主导航
    $('.leftSliderBar .toggle').click(function () {
      $(this).parent('.leftSliderBar').toggleClass('leftSliderMinBar');
      $(this).parent('.leftSliderBar').parent('.leftSliderBarWrap').toggleClass('min');
      $(this).parent('.leftSliderBar').parent('.leftSliderBarWrap').next('.mainContentWrap').toggleClass('leftSliderOpen').toggleClass('leftSliderMin');
    });
  },
  methods: {
    getAgentLoginUrl() {
      let that = this;
      that.showTost(1, '正在前往页面');
      let pathInfo = this.$router.resolve({
        path: '/gamePage',
        query: {
          dailiD: 1,
        },
      });
      window.open(pathInfo.href, '_blank');
    },
    openDaoTime() {
      this.$parent.openDaoTime();
    },
    closeDaoTime() {
      this.$parent.closeDaoTime();
    },
    getUserInfoShowLoding() {
      this.$parent.getUserInfoShowLoding();
    },
    goGamePage(name, type, code) {
      let that = this;
      that.showLoading();
      type = type == null ? 0 : type;
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type, game_code: code, is_mobile_url: 0 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.hideLoading();
            window.open(res.data.url, '_self');
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    openGamePage(name, type, code) {
      let that = this;
      type = type == null ? 0 : type;

      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');
        $('.mask').fadeOut(300);
        $('.mask.login').fadeIn(300);
        return;
      }

      that.showTost(1, '正在前往打开游戏页面');
      let pathInfo = this.$router.resolve({
        path: '/gamePage',
        query: {
          name,
          type,
          code,
        },
      });
      window.open(pathInfo.href, '_blank');

      // let routeData = this.$router.resolve({
      //    name: 'gamePage',
      //    params: { name, type,code}
      //  });
      // window.open(routeData.href, '_blank');
      // return
      // window.open(`/gamePage?name=${name}&type=${type}&code=${code}`, '_blank');
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    goNav(url) {
      let that = this;
      if (url == '/userredpacket') {
        if (!that.$store.state.token) {
          that.showTost(0, '请登录！');

          return;
        }
        let routerData = this.$router.resolve({
          path: `/userredpacket`,
        });
        window.open(routerData.href, '_blank');

        return;
      }
      if (url == this.$route.fullPath) {
        if (url == '/') {
          return;
        }
        that.showTost(0, '已在当前页面！');
        return;
      }
      this.url = url;
      if (url == '/accountSetting') {
        if (!sessionStorage.getItem('token')) {
          $('.mask').fadeOut(300);
          $('.mask.login').fadeIn(300);
          return;
        }
      }
      this.$router.push({ path: url });
    },
    openKefu() {
      let that = this;
      that.showTost(1, '正在链接人工客服');
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          window.open(res.data.url);
        }
      });
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          that.userInfo = res.data;
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    showTost(type, title) {
      // error  success
      let str = type ? 'success' : 'error';
      $('body').append(`
            <div role="alert" class="ants-message el-message el-message--${str}" style="top: 20px; z-index: 2009;"><i class="el-message__icon el-icon-${str}"></i>
            <p class="el-message__content">${title}
            </p></div>`);
      setTimeout('$(".ants-message").detach()', 2000);
    },
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.path = this.$route.path;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
}
.footer[data-v-5abf1f28] {
  position: relative;
  background: #0a0a0a;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#0a0a0a), to(#1b1b1b));
  background-image: linear-gradient(180deg, #0a0a0a, #1b1b1b);
  -webkit-filter: progid:dximagetransform.microsoft.gradient(startcolorstr=#0a0a0a,endcolorstr=#1b1b1b,gradientType=0);
  filter: progid:dximagetransform.microsoft.gradient(startcolorstr=#0a0a0a,endcolorstr=#1b1b1b,gradientType=0);
}
.footer .fixed-bottom[data-v-5abf1f28] {
  position: fixed;
  right: 0.2rem;
  bottom: 1rem;
  z-index: 98;
}
.stockDividendPendant.min[data-v-05425edc] {
  width: 40px;
  height: 40px;
}

.min[data-v-5abf1f28] {
  width: 0.44rem;
  height: 0.44rem;
}
.stockDividendPendant[data-v-05425edc] {
  position: relative;
  width: 120px;
  height: 120px;
  font-size: 12px;
  color: #e5edff;
  cursor: pointer;
}
.clearfix {
  zoom: 1;
}
.footer .fixed-bottom .tool .btn-min[data-v-5abf1f28] {
  display: block;
  float: right;
  width: 0.44rem;
  height: 0.44rem;
  margin-bottom: 0.1rem;
  text-align: center;
  cursor: pointer;
  background-position: -0.42rem -0.38rem;
}
.footer .fixed-bottom .tool .btn-min .cs[data-v-5abf1f28] {
  width: 0.44rem;
  height: 0.44rem;
}
.svg-icon[data-v-338e1447] {
  width: 10em;
  height: 10em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.footer .fixed-bottom {
  bottom: 3rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue